import React from 'react'
import CircularProgress from "@mui/material/CircularProgress";
import {useStyles} from "./LoadingProgressIndication.css";

const LoadingProgressIndication = ({text, size}) => {

    const classes = useStyles()

    return <div className={classes.progress}>
        <div>
            <CircularProgress size={size || 100}/>
            <p>{text}</p>
        </div>
    </div>
}
export default LoadingProgressIndication
